// Vendor libraries
import { bootstrapAppModule } from 'NewAngular/utils/app-bootstrapping';
// Modules
import { MutualFundsScatterPlotAppModule } from './app.module';
bootstrapAppModule(MutualFundsScatterPlotAppModule);
